import { createToastGlobal as f } from "./design-system.es2.js";
import { default as F } from "./design-system.es3.js";
import { default as H } from "./design-system.es4.js";
import { default as S } from "./design-system.es5.js";
import { default as k } from "./design-system.es6.js";
import { toastKey as E } from "./design-system.es7.js";
import { createErrorBannerGlobal as l } from "./design-system.es8.js";
import { default as w } from "./design-system.es9.js";
import { default as R } from "./design-system.es10.js";
import { default as U } from "./design-system.es11.js";
import { errorBannerKey as q } from "./design-system.es12.js";
import { createConfirmDialogGlobal as u } from "./design-system.es13.js";
import { default as J } from "./design-system.es14.js";
import { default as V } from "./design-system.es15.js";
import { default as X } from "./design-system.es16.js";
import { default as Z } from "./design-system.es17.js";
import { default as $ } from "./design-system.es18.js";
import { default as oe } from "./design-system.es19.js";
import { confirmDialogKey as te } from "./design-system.es20.js";
import { createI18nProvider as d } from "./design-system.es21.js";
import { default as se } from "./design-system.es22.js";
import m from "./design-system.es23.js";
import "vue";
import p from "./design-system.es24.js";
import { default as le } from "./design-system.es25.js";
import * as b from "./design-system.es26.js";
import { registerGlobalComponents as x } from "./design-system.es27.js";
import { createConfigProvider as n } from "./design-system.es28.js";
import { configKey as de } from "./design-system.es28.js";
import { default as pe } from "./design-system.es29.js";
import { default as ne } from "./design-system.es30.js";
import { actionsKey as De, createActionsContainer as ce, createActionsProvider as ge } from "./design-system.es31.js";
import { default as Ce } from "./design-system.es32.js";
import { default as be } from "./design-system.es33.js";
import { createListProvider as Pe, listContextKey as Ie, useListContext as ye } from "./design-system.es34.js";
import { default as Fe } from "./design-system.es35.js";
import { default as He } from "./design-system.es36.js";
import { default as Se } from "./design-system.es37.js";
import { default as ke } from "./design-system.es38.js";
import { default as Ee } from "./design-system.es39.js";
import { default as we } from "./design-system.es40.js";
import { default as Re } from "./design-system.es41.js";
import { default as Ue } from "./design-system.es42.js";
import { default as qe } from "./design-system.es43.js";
import { default as Je } from "./design-system.es44.js";
import { default as Ve } from "./design-system.es45.js";
import { default as Xe } from "./design-system.es46.js";
import { default as Ze } from "./design-system.es47.js";
import { default as $e } from "./design-system.es48.js";
import { default as oo } from "./design-system.es49.js";
import { default as to } from "./design-system.es50.js";
import { default as so } from "./design-system.es51.js";
import { default as lo } from "./design-system.es52.js";
import { default as mo } from "./design-system.es53.js";
import { default as xo } from "./design-system.es54.js";
import { default as io } from "./design-system.es55.js";
import { default as co } from "./design-system.es56.js";
import { default as To } from "./design-system.es57.js";
import { default as Mo } from "./design-system.es58.js";
import { default as Bo } from "./design-system.es59.js";
import { default as Io } from "./design-system.es60.js";
import { default as Go } from "./design-system.es61.js";
import { default as vo } from "./design-system.es62.js";
import { default as Lo } from "./design-system.es63.js";
import { default as ho } from "./design-system.es64.js";
import { default as Ao } from "./design-system.es65.js";
import { default as Ko } from "./design-system.es66.js";
import { default as Oo } from "./design-system.es67.js";
import { default as Qo } from "./design-system.es68.js";
import { default as jo } from "./design-system.es69.js";
import { default as zo } from "./design-system.es70.js";
import { default as No } from "./design-system.es71.js";
import { default as Wo } from "./design-system.es72.js";
import { default as Yo } from "./design-system.es73.js";
import { default as _o } from "./design-system.es74.js";
import { default as er } from "./design-system.es75.js";
import { default as rr } from "./design-system.es76.js";
import { default as ar } from "./design-system.es77.js";
import { default as fr } from "./design-system.es78.js";
import { default as ur } from "./design-system.es79.js";
import { default as mr } from "./design-system.es80.js";
import { default as xr } from "./design-system.es81.js";
import { default as ir } from "./design-system.es82.js";
import { default as cr } from "./design-system.es83.js";
import { default as Tr } from "./design-system.es84.js";
import { default as Mr } from "./design-system.es85.js";
import { default as Br } from "./design-system.es86.js";
import { default as Ir } from "./design-system.es87.js";
import { default as Gr } from "./design-system.es88.js";
import { default as vr } from "./design-system.es89.js";
import { default as Lr } from "./design-system.es90.js";
import { default as hr } from "./design-system.es91.js";
import { default as Ar } from "./design-system.es92.js";
import { default as Kr } from "./design-system.es93.js";
import { default as Or } from "./design-system.es94.js";
import { default as Qr } from "./design-system.es95.js";
import { default as jr } from "./design-system.es96.js";
import { default as zr } from "./design-system.es97.js";
import { default as Nr } from "./design-system.es98.js";
import { default as Wr } from "./design-system.es99.js";
import { default as Yr } from "./design-system.es100.js";
import { default as _r } from "./design-system.es101.js";
import { default as et } from "./design-system.es102.js";
import { default as rt } from "./design-system.es103.js";
import { default as at } from "./design-system.es104.js";
import { default as ft } from "./design-system.es105.js";
import { default as ut } from "./design-system.es106.js";
import { default as mt } from "./design-system.es107.js";
import { default as xt } from "./design-system.es108.js";
import { default as it } from "./design-system.es109.js";
import { default as ct } from "./design-system.es110.js";
import { default as Tt } from "./design-system.es111.js";
import { default as Mt } from "./design-system.es112.js";
import { default as Bt } from "./design-system.es113.js";
import { default as It } from "./design-system.es114.js";
import { default as Gt } from "./design-system.es115.js";
import { default as vt } from "./design-system.es116.js";
import { default as Lt } from "./design-system.es117.js";
import { default as ht } from "./design-system.es118.js";
import { usePopper as At } from "./design-system.es119.js";
function I(r = {}) {
  const o = {}, t = f();
  o.toast = t;
  const a = l();
  o.errorBanner = a;
  const s = u();
  return o.confirmDialog = s, o.install = (e) => {
    x(e, r.components), t.install(e), a.install(e), s.install(e), d(e), m(e, r), n(e, r), p();
  }, o;
}
export {
  ne as DsActionsContainer,
  Fe as DsAvatar,
  He as DsBleed,
  Se as DsBox,
  ke as DsButton,
  Ee as DsButtonGroup,
  we as DsCard,
  Re as DsCardBody,
  Ue as DsCardFooter,
  qe as DsCardHeader,
  Je as DsCheckbox,
  Xe as DsCheckboxGroup,
  Ve as DsChip,
  Ze as DsCollapsible,
  $e as DsColorField,
  oo as DsColorPicker,
  J as DsConfirmDialog,
  V as DsConfirmDialogContainer,
  to as DsDatePicker,
  pe as DsDivider,
  so as DsDropdown,
  lo as DsEditable,
  mo as DsEditableText,
  w as DsErrorBanner,
  R as DsErrorBannerContainer,
  io as DsFileUploadInput,
  co as DsFilledButton,
  xo as DsGuide,
  To as DsHtmlPreview,
  Mo as DsIcon,
  Bo as DsIconButton,
  Io as DsIllustration,
  Go as DsInfiniteScroll,
  vo as DsInline,
  Lo as DsInlineAlert,
  ho as DsInlineAlertFooterLink,
  Ao as DsInputField,
  Ko as DsLink,
  be as DsList,
  Oo as DsListItem,
  Ce as DsListSectionHeading,
  Qo as DsLogo,
  se as DsMediaQuery,
  jo as DsMenuContainer,
  zo as DsMenuDivider,
  No as DsMenuEmpty,
  Wo as DsMenuFooter,
  Yo as DsMenuGroupHeader,
  _o as DsMenuItem,
  er as DsMenuItems,
  rr as DsMenuLoading,
  ar as DsMenuSearchHeader,
  fr as DsMenuTrigger,
  X as DsModal,
  Z as DsModalHeader,
  $ as DsModalHeaderTitle,
  xr as DsMultiSelectMenuItem,
  ur as DsMultiselect,
  mr as DsMultiselectMenu,
  ir as DsOutlineButton,
  cr as DsPager,
  Tr as DsPagerButton,
  Mr as DsPaginationFooter,
  Br as DsPhoneInput,
  Ir as DsPlaceholder,
  Gr as DsPopover,
  vr as DsProgressBar,
  Lr as DsRadio,
  hr as DsRadioGroup,
  Ar as DsRouterPaginationFooter,
  Kr as DsSelectField,
  Qr as DsSpinner,
  Or as DsStack,
  jr as DsStatus,
  zr as DsTab,
  _r as DsTabHeader,
  Wr as DsTabHeaderItem,
  Yr as DsTabHeaderLink,
  Nr as DsTabLinks,
  et as DsTableGrid,
  rt as DsTableGridColumn,
  at as DsTableGridTrowser,
  ft as DsTabset,
  ut as DsText,
  mt as DsTextAreaField,
  xt as DsTextButton,
  it as DsTextHighlighter,
  F as DsToast,
  S as DsToastContainer,
  H as DsToastGroup,
  ct as DsToggle,
  Tt as DsToggleButton,
  Mt as DsToggleSwitch,
  Bt as DsTooltip,
  It as DsTooltipTrigger,
  Gt as DsTrowser,
  De as actionsKey,
  b as components,
  de as configKey,
  te as confirmDialogKey,
  ce as createActionsContainer,
  ge as createActionsProvider,
  I as createDesignSystem,
  Pe as createListProvider,
  q as errorBannerKey,
  Ie as listContextKey,
  E as toastKey,
  oe as useConfirmDialog,
  U as useErrorBanner,
  p as useFocusOnKeyboardOnly,
  vt as useI18n,
  ye as useListContext,
  le as useMediaQuery,
  Lt as usePager,
  ht as usePagination,
  At as usePopper,
  k as useToast
};
//# sourceMappingURL=design-system.es.js.map
